import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const MONTHS = ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"];

export const MonthPicker = ({ value, onChange, testId = "month-picker", className = "" }) => {
  const [y, m] = (value || new Date().toISOString().slice(0, 7)).split("-").map(Number);
  const set = (yy, mm) => onChange(`${yy}-${String(mm).padStart(2, "0")}`);
  const shift = (d) => {
    let mm = m + d, yy = y;
    if (mm < 1) { mm = 12; yy -= 1; }
    if (mm > 12) { mm = 1; yy += 1; }
    set(yy, mm);
  };
  const curYear = new Date().getFullYear();
  const years = [];
  for (let yy = curYear - 4; yy <= curYear + 1; yy++) years.push(yy);
  if (!years.includes(y)) years.unshift(y);

  return (
    <div className={`inline-flex items-center gap-1 ${className}`} data-testid={testId}>
      <button
        type="button"
        onClick={() => shift(-1)}
        className="h-9 w-8 flex items-center justify-center rounded-md border border-zinc-300 bg-white hover:bg-zinc-100 transition-colors"
        data-testid={`${testId}-prev`}
        title="Luna precedentă"
      >
        <ChevronLeft size={15} />
      </button>
      <Select value={String(m)} onValueChange={(v) => set(y, Number(v))}>
        <SelectTrigger className="h-9 w-[130px] font-semibold" data-testid={`${testId}-month`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {MONTHS.map((name, i) => (
            <SelectItem key={i} value={String(i + 1)} data-testid={`${testId}-month-${i + 1}`}>{name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={String(y)} onValueChange={(v) => set(Number(v), m)}>
        <SelectTrigger className="h-9 w-[86px] font-semibold" data-testid={`${testId}-year`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {years.map((yy) => (
            <SelectItem key={yy} value={String(yy)}>{yy}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <button
        type="button"
        onClick={() => shift(1)}
        className="h-9 w-8 flex items-center justify-center rounded-md border border-zinc-300 bg-white hover:bg-zinc-100 transition-colors"
        data-testid={`${testId}-next`}
        title="Luna următoare"
      >
        <ChevronRight size={15} />
      </button>
    </div>
  );
};
